import { typePropertyIsNotAllowedInProps } from "@ngrx/store/src/models";
import { Product } from "../data/product-data";
import { Type } from "@angular/core";
import { NbMenuItem } from "@nebular/theme";

export enum BannerLayoutClasses {
    LAYOUT_1 = "layout-class-1",
    LAYOUT_2 = "layout-class-2",
    LAYOUT_3 = "layout-class-3",
    LAYOUT_4 = "layout-class-4",
    LAYOUT_5 = "layout-class-5",
    LAYOUT_6 = "layout-class-6",
    LAYOUT_7 = "layout-class-7"
}
export enum SliderType{
    ROW = "row",
    TABBED = "tabbed",
    SHOW = "show",
    EYE = "eye"
}
export enum FontSizeClasses{
    TINY = "fnt-size-tiny",
    SMALL = "fnt-size-small",
    MEDIUM_SMALL = "fnt-size-medium",
    STANDARD = "fnt-size-standard",
    STANDARD_LARGE = "fnt-size-standard-large",
    STANDARD_LARGER = "fnt-size-standard-larger",
    LARGE = "fnt-size-large",
    LARGER = "fnt-size-larger",
    VERY_LARGE = "fnt-size-very-large",
    GIANT = "fnt-size-gigantic",
    ENORMOUS = "fnt-size-enormous"    
/*     {name:"Tiny",value:"0.625rem",class:"fnt-size-tiny"},
    {name:"Small",value:"0.75rem",class:"fnt-size-small"},
    {name:"Medium Small",value:"0.875rem",class:"fnt-size-medium"},
    {name:"Standard",value:"0.9375rem",class:"fnt-size-standard"},
    {name:"Standard Large",value:"1rem",class:"fnt-size-standard-large"},
    {name:"Standard Larger",value:"1.125rem",class:"fnt-size-standard-larger"},
    {name:"Large",value:"1.375rem",class:"fnt-size-large"},
    {name:"Larger",value:"1.625rem",class:"fnt-size-larger"},
    {name:"Very Large",value:"1.875rem",class:"fnt-size-very-large"},
    {name:"Giant",value:"2rem",class:"fnt-size-gigantic"},
    {name:"Enormous",value:"2.25rem",class:"fnt-size-enormous"} */
}
export enum ContainerLayouts{
    CONTENT_TOP = "container-content-top",
    CONTENT_MIDDLE = "container-content-middle",
    CONTENT_BOTTOM = "container-content-bottom"
    /* {name:"Content Top",class:"container-content-top"},
    {name:"Content Middle",class:"container-content-middle"},
    {name:"Content Bottom",class:"container-content-bottom"} */
}

export enum BorderWidths {
    NONE = "none",
    THIN = "border-thin",
    MEDIUM_THIN = "border-medium-thin",
    MEDIUM = "border-medium",
    MEDIUM_THICK = "border-medium-thick",
    THICK = "border-thick"
    /* {name:"No Border",class:"none"},
    {name:"Thin",class:"border-thin"},
    {name:"Medium Thin Border",class:"border-medium-thin"},
    {name:"Medium Border",class:"border-medium"},
    {name:"Medium Thick Border",class:"border-medium-thick"},
    {name:"Thick Border",class:"border-thick"} */
}

export enum BorderRadiuses {
    RADIUS_1 = "border-radius-1",
    RADIUS_2 = "border-radius-2",
    RADIUS_3 = "border-radius-3",
    RADIUS_4 = "border-radius-4",
    RADIUS_5 = "border-radius-5",
    RADIUS_6 = "border-radius-6",
    RADIUS_7 = "border-radius-7",
    RADIUS_8 = "border-radius-8",
    RADIUS_9 = "border-radius-9",
    RADIUS_10 = "border-radius-10",
    RADIUS_11 = "border-radius-11",
    RADIUS_12 = "border-radius-12",
    RADIUS_13 = "border-radius-13",
    RADIUS_14 = "border-radius-14",
    RADIUS_15 = "border-radius-15",
    RADIUS_16 = "border-radius-16",
    RADIUS_17 = "border-radius-17",
    RADIUS_18 = "border-radius-18"

/* 
    {name:"Border 1",class:"border-radius-1"},
    {name:"Border 2",class:"border-radius-2"},
    {name:"Border 3",class:"border-radius-3"},
    {name:"Border 4",class:"border-radius-4"},
    {name:"Border 5",class:"border-radius-5"},
    {name:"Border 6",class:"border-radius-6"},
    {name:"Border 7",class:"border-radius-7"},
    {name:"Border 8",class:"border-radius-8"},
    {name:"Border 9",class:"border-radius-9"},
    {name:"Border 10",class:"border-radius-10"},
    {name:"Border 11",class:"border-radius-11"},
    {name:"Border 12",class:"border-radius-12"},
    {name:"Border 13",class:"border-radius-13"},
    {name:"Border 14",class:"border-radius-14"},
    {name:"Border 15",class:"border-radius-15"},
    {name:"Border 16",class:"border-radius-16"},
    {name:"Border 17",class:"border-radius-17"},
    {name:"Border 18",class:"border-radius-18"} */
}

export enum PresetPadding{
    TINY = "0.3125rem 0.625rem",
    SMALL = "0.4375rem 0.875rem",
    Default = "0.5rem",
    MEDIUM_SMALL = "0.6875rem 1.125rem",
    MEDIUM = "0.8125rem 1.125rem",
    MEDIUM_LARGE = "0.9375rem 1.375rem",
    LARGE = "1.0625rem 1.625rem",
    EXTRA_LARGE = "1.1875rem 1.875rem"
    /* {name:"Tiny",class:"kve-pad-tiny",value:"0.3125rem 0.625rem"},
    {name:"Small",class:"kve-pad-small",value:"0.4375rem 0.875rem"},
    {name:"Default",class:"kve-pad-default",value:"0.5rem"},
    {name:"Medium Small",class:"kve-pad-medium-small",value:"0.6875rem 1.125rem"},
    {name:"Medium",class:"kve-pad-medium",value:"0.8125rem 1.125rem"},
    {name:"Medium Large",class:"kve-pad-large-medium",value:"0.9375rem 1.375rem"},
    {name:"Large",class:"kve-pad-large",value:"1.0625rem 1.625rem"},
    {name:"Extra Large",class:"kve-pad-extralarge",value:"1.1875rem 1.875rem"} */
}

export enum HorisontalAlign{
    ALIGN_LEFT = "justify-left",
    ALIGN_CENTER = "justify-center",
    ALIGN_RIGHT = "justify-right"
    /* {name:"Align Left",class:"justify-left"},
    {name:"Align Center",class:"justify-center"},
    {name:"Align Right",class:"justify-right"} */ 
}
export enum ContentEnum {
    PRODUCT = "Product Content",
    CATEGORY = "Category Content",
    PROMO_TEXT = "Promotional Text",
    CALL_TO_ACTION = "Call To Action",
    BLOG_ARTICLE_LINK = "Blog Article Link",
    CATEGORY_LINK = "Category Link",
    PRODUCT_LINK = "Product Link",
    BANNER = "Banner",
    HEADLINE = "Headline",
    SUB_HEADLINE = "Sub Headline",
    GALLERY = "Gallery",
    PRODUCT_CLASSIFICATION = "Product Classification",
    PRODUCT_ID = "Product Identification",
    PRODUCT_STD_FEATS = "Product Standard Features",
    PRODUCT_SELC_FEATS = "Product Selectable Features",
    PRODUCT_PRICING = "Product Price",
    PRODUCT_RATING = "Product Rating",
    PRODUCT_DIMENSIONS = "Product Rating",
    PRODUCT_PACKAGING = "Product Packaging",
    PRODUCT_SHORT_DESC = "Product Short Description",
    PRODUCT_LONG_DESC = "Product Long Description",
    PRODUCT_REVIEWS = "Product Reviews",
    PRODUCT_ADD_TO_CART = "Add To Cart",
    PRODUCT_SHARE = "Product Share",
    PRODUCT_DELIVERY = "Delivery",
    PRODUCT_INVENTORY = "Inventory",
    PRODUCT_VARIANT = "Product Variant",
    GENERAL_TEXT = "General Text",
    SHOPPINGCART = "Shopping Cart",
    BLOG_HEADER = "Blog Header",
    BLOG_SUMMARY = "Blog Summary",
    BLOG_MAIN = "Blog Main",
    BLOG_SHARE = "Blog Share",
    BLOG_COMMENTS = "Blog Comments",
    BLOG_IMAGE = "Blog Image",
    NAV_LIST = "Navigation List",
    PRODUCT_CELL = "Product Cell",
    HERO_IMAGE = "Hero Image",
    FEATURE = "Feature",
    TESTIMONIAL = "Testimonial"
}

export enum InputType{
    TEXTAREA = "textarea",
    INPUT = "input",
    EMAIL = "email"
}

export enum LinkType{
    TEXT = "Link Text",
    BUTTON = "Link Button",
    ICON = "Link Icon"
}

export interface BaseContentElement {
    elId:string,
    name:string,
    fontSizeCls?:FontSizeClasses,
    fontFamily?:string,
    horizontalAlign?:HorisontalAlign,
    verticalAlign?:ContainerLayouts,
}

export interface ImageContentElement {
    imgSrc?:string;
    type?:string;
}

export interface LinkContentElement {
    type?:LinkType;
    linkType?:LinkType
    action?:string,
    iconClass?:string,
}

export interface HeaderContentElement {
    text?:string;
    type?:string;
}

export interface TextContentElement {
    text?:string;
}

export interface GenericContentElement<T> extends BaseContentElement{
    content:T;
}
//Content Element enum used as css class. Use only single words or hyfenated words 
export enum ContentElementEnum {
    HEADER = "header",
    HEADING = "heading",
    SUB_HEADER = "sub-header",
    IMAGE = "image",
    LINK = "link",
    TEXT = "text",
    NUMBER = "number",
    ACTION = "action",
    TABLE = "table",
    DATE = "date",
    HTML = "html",
    TRANSFORM = "tranform",
    SELECT = "select",
    LIST_ITEM = "list-item",
    BUTTON = "button",
    SVG = "svg",
    INPUTFIELD = "input-field",
    CAPTION = "caption",
    SUMMARY = "summary",
    BYLINE = "byline"
}

export enum VisibilityEnum {
    VISIBLE = "Visible",
    HIDDEN = "Hidden",
    HIDDEN_ON_MOBILE = "Hidden On Mobile "
}

export interface ContentElement{
    elId:string,
    name:string,
    fieldName?:string,
    description?:string,
    contentElementEnum?:ContentElementEnum,
    productId?:string,
    categoryId?:string,
    articleContentId?:string;
    imgSrc?:string,
    inputType?:InputType,
    isHeader?:boolean,
    fontSizeCls?:FontSizeClasses,
    fontFamily?:string,
    horizontalAlign?:HorisontalAlign,
    verticalAlign?:ContainerLayouts,
    text?:string,
    fontSizeClass?:FontSizeClasses;
    fontSize?:string,
    color?:string,
    background?:string,
    fontWeightClass?:string,
    fontWeight?:string,
    paddingClass?:PresetPadding,
    padding?:string,
    paddingTop?:string;
    paddingBottom?:string;
    paddingLeft?:string;
    paddingRight?:string;
    parentPadding?:string;
    borderWidthCls?:BorderWidths,
    borderRadiusCls?:BorderRadiuses,
    borderWidth?:string;
    borderColor?:string,
    borderStyle?:string;
    borderRadius?:string;
    borderRadiusTopLeft?:string;
    borderRadiusTopRight?:string;
    borderRadiusBottomRight?:string;
    borderRadiusBottomLeft?:string;
    containerClasses?:string[];
    classes?:string[],
    parentBorder?:string,
    parentBorderRadius?:string,
    parentBackground?:string;
    parentBorderColor?:string,
    parentBorderWidth?:string,
    parentBorderStyle?:string,
    containerBackground?:string;
    containerPadding?:string;
    widthClass?:string;
    isLink?:boolean;
    linkType?:LinkType
    action?:LinkTarget,
    iconClass?:string,
    autoGenerated?:boolean,
    visibility?:VisibilityEnum,
    selectOptions?:SelectOption[],
    underLineThickness?:string;
    underLineDistance?:string;
    border?:string
}

export enum LinkTarget{
    PRODUCT = "product",
    CATEGORY = "category",
    ARTICLE = "article"
}

export interface SelectOption{
    description:string;
    key:string;
}
export enum OrientationEnum {
    LANDSCAPE = 'landscape',
    PORTRAIT = 'portrait',
    CIRCLE = 'circle'
}

export enum BannerLayoutEnum {
    NOSPLIT_IMG = 'No split with Image',
    SPLIT_VERT_IMG = 'Vertrical Split With Image',
    SPLIT_VERT_NOIMG = 'Vertrical Split No Image',
    SPLIT_HOR_NOIMG = 'Horisontal Split No Image',
    WAVE_HOR_NOIMG = 'Wave No Image'

}

export enum BloglistLayoutEnum {
    LAYOUT_1 = "layout-1",
    LAYOUT_2 = "layout-2", 
    LAYOUT_3 = "layout-3",
    LAYOUT_4 = "layout-4",
    FOUR_COL_PORTRIAT = "col-4-portrait",
    FOUR_COL_LAND = "col-4-landscape",
    THREE_COL_PORTRIAT = "col-3-portrait",
    TWO_COL_LAND = "col-2-landscape",
    ONE_COL_LAND = "col-1-landscape",
    SQUARE_IMG_Top = 'Square Image Top',
    CIRCLE_IMG_Top = 'Circle Image Top',
    INSET_IMG_Top = 'Inset Image Top',
}

export enum ProductRowLayoutEnum{
    SIX_COL_PORTRIAT = "col-6-portrait",
    FOUR_COL_PORTRIAT = "col-4-portrait",
    FOUR_COL_LAND = "col-4-landscape",
    THREE_COL_PORTRIAT = "col-3-portrait",
    TWO_COL_LAND = "col-2-landscape",
    ONE_COL_LAND = "col-1-landscape",
}

export enum GridLayoutEnum{
    GRID_3 = "grid-3",
    GRID_4 = "grid-4",
    GRID_5 = "grid-5",
    GRID_6 = "grid-6",
    GRID_7 = "grid-7",
    GRID_8 = "grid-8",
    GRID_9 = "grid-9"
}

export enum HeroLayoutEnum{
    LAYOUT_1 = "layout-1",
    LAYOUT_2 = "layout-2", 
    LAYOUT_3 = "layout-3",
    LAYOUT_4 = "layout-4",
    LAYOUT_5 = "layout-5",
    LAYOUT_6 = "layout-6", 
    LAYOUT_7 = "layout-7",
    GRID_3_3_1 = "cell-3-3-1",
    GRID_4_4_1 = "cell-4-4-1",
    GRID_3_2_2 = "cell-3-2-2",
    GRID_4_2_2a = "cell-4-2-2a",
    GRID_3_1_3 = "cell-3-1-3",
    GRID_4_2_3 = "cell-4-2-3",
    GRID_4_2_2b = "cell-4-2-2b"
}

export enum VerticalAlignEnum{
    TOP = "top",
    MIDDLE = "middle",
    BOTTOM = "bottom"
}

export enum LargeImagePositionEnum {
    START = 'start',
    MIDDLE_1 = 'middleOne',
    MIDDLE_2 = 'middleTwo',
    END = 'end'
}
export enum RendererType{
    GRID = "grid",
    ROW = "row",
    BANNER = "banner",
    CATEGORY = "category",
    BLOGLIST = "bloglist",
    NEWSLETTER = "news-letter-sign-up",
    STOREFEATURES = "store-features",
    SLIDER = "slider",
    RICH_TEXT = "rich-text",
    TESTIMONIALS = "testimonials",
    HEROIMAGE = "hero-image",
    PRODUCT = "product",
    CART = "cart",
    BLOG = "blog",
}

export enum BgPositionEnum {
    TOP = "top",
    BOTTOM = "bottom",
    RIGHT = "right",
    LEFT = "left",
    CENTER = "center"
}
export enum BannerCellHeightEnum {
    THREE_TWENTY = "320px",
    FOUR_TWENTY = "420px",
    FIVE_FOURTY = "540px"
}
export interface SectionData{
    rendererType?:RendererType,
    title?:ContentElement,
    heading?:string,
    product?:Product,
    bannerOptions?:any,
    imageOrientation?:OrientationEnum,
    width?:number,
    height?:number,
    marginBottom?:number,
    testimonialOptions?:any,
    richTextOptions?:any,
    layoutClass?:BloglistLayoutEnum | GridLayoutEnum | HeroLayoutEnum | TestimonialLayoutEnum,
    wrapperClass?:string,
    bgPosition?:BgPositionEnum,
    cellOrientation?:OrientationEnum,
    blogListOptions?:any,
    gridOptions?:any,
    rowCells?:any[],
    numberOfElements?:number,
    rowOptions?:any,
    isPreview?:boolean,
    verticalAlign?:VerticalAlignEnum,
    bgClass?:string,
    bgColor?:string,
    cellHeight?:string,
    selectedCell?:GridCell | RowCell,
    imgSrc?:string,
    borderColor?:string,
    borderWidth?:string,
    borderStyle?:string,
    borderRadius?:string,
    border?:string,
    padding?:string,
    color?:string
}

export declare enum ContentType {
    PRODUCT_SUMMARY = "Product Summary",
    PRODUCT_LIST = "Product List",
    PRODUCT_DETAIL = "Product Detail",
    BLOG_LIST = "Blog List",
    TESTIMONIALS = "Testimonials",
    BLOG_ARTICLE = "Blog Article",
    RICH_TEXT = "Rich Text Block",
    BRANDS = "Brands",
    FORM = "Form"
}

export enum ContentStatusEnum {
    CTNT_IN_PROGRESS = "In Progress",
    CTNT_INITIAL_DRAFT = "Initial Draft",
    CTNT_REVISED_DRAFT = "Revised Draft",
    CTNT_FINAL_DRAFT = "Final Draft",
    CTNT_PUBLISHED = "Published",
    CTNT_DEACTIVATED = "CTNT_DEACTIVATED"
}

export interface Section {
    title?: ContentElement;
    contentType?: ContentType;
    sectionId?: string;
    index?: number;
    rendererType?: RendererType;
    status?: ContentStatusEnum;
    sectionData?: SectionData;
    sectionTemplate?: Type<any>;
}

export class KwikstoreSection<T> {
    section:T;
    name:string;
    heading:string;
    subHeading:string;
    topOffset:number;
    fullWidth:boolean;
    background:boolean;
    backgroundColor:string;
    categoryId:string;
    productId:string;
    fontSizeDesktop:number;
    fontSizeMobile:number;
    sectionData:SectionData;
    gridOptions:GridOptions;
    rowOptions:RowOptions;
    bannerOptions:BannerOptions;
    blogListOptions:BlogListOptions;
    sliderOptions:SliderOptions;
    newsLetterOptions:NewsLetterOptions;
    hideOnMobile:boolean;
    status:ContentStatusEnum;
    constructor(options:{
        section?:T,
        name?:string,
        heading?:string,
        subHeading?:string,
        topOffset?:number,
        fullWidth?:boolean,
        background?:boolean,
        backgroundColor?:string,
        categoryId?:string,
        productId?:string;
        fontSizeDesktop?:number,
        fontSizeMobile?:number,
        hideOnMobile?:boolean,
        sectionData?:SectionData,
        status?:ContentStatusEnum
    } = {}){
        this.section = options.section;
        this.name = options.name;
        this.heading = options.heading;
        this.sectionData = options.sectionData;
        this.subHeading = options.subHeading;
        this.topOffset = options.topOffset || 0;
        this.fullWidth = options.fullWidth || true;
        this.hideOnMobile = options.hideOnMobile || true;
        this.background = options.background || false;
        this.backgroundColor = options.backgroundColor || "#fff";
        this.categoryId = options.categoryId;
        this.productId = options.productId;
        this.fontSizeDesktop = options.fontSizeDesktop;
        this.fontSizeMobile = options.fontSizeMobile;
        this.status = options.status
    }

    typeof(): string {
        return typeof this.section;       
    }
}
export enum HeaderFooterPosition {
    INSIDE = "inside",
    OUTSIDE = "outside",
    NONE = "none"
}
export enum GridCellClass {
    A = "a",
    B = "b",
    C = "c",
    D = "d",
    E = "e",
    F = "f",
    G = "g",
    H = "h",
    I = "i"
}

export class GridCellElement<T>{
    cellElementType:T;
    fieldName:string;
    editable:boolean;
    defaultValue:string;
    constructor(options:any){}

    setFieldName(fieldName:string){
        this.fieldName = fieldName
    }
    getFieldName():string{
        return this.fieldName
    }

    setEditable(editable:boolean){
        this.editable = editable;
    }

    getEditable():boolean{
        return this.editable;
    }

    setDefaulValue(defaultValue:string){
        this.defaultValue = defaultValue;
    }

    getDefaultValue():string{
        return this.defaultValue
    }
}
export interface GridCellHeadingOptions {
    type?:string;
    text?:string;
    style?:string;
}
export class GridCellHeading extends GridCellElement<GridCellHeading>{
    options:GridCellHeadingOptions;
    constructor(options:GridCellHeadingOptions){
        super(options);
        this.options = options;
    }

    getOptions():GridCellHeadingOptions{
        return this.options
    }
}
export interface GridCellImageOptions {
    src?:string;
    style?:string;
}
export class GridCellImage extends GridCellElement<GridCellImage>{
    options:GridCellHeadingOptions;
    constructor(options:GridCellImageOptions){
        super(options);
        this.options = options;
    }
    getOptions():GridCellImageOptions{
        return this.options
    }
}

export interface GridCellTextOptions {
    text?:string;
    style?:string;
}

export class GridCellText extends GridCellElement<GridCellImage>{
    options:GridCellTextOptions;
    constructor(options:GridCellTextOptions){
        super(options);
        this.options = options;
    }
    getOptions():GridCellTextOptions{
        return this.options
    }
}
export interface GridCellFooterOptions {
    text?:string;
    style?:string;
}
/* export class GridCellFooter extends GridCellElement<GridCellFooter>{
    options:GridCellFooterOptions;
    constructor(options:GridCellFooterOptions){
        super(options);
        this.options = options;
    }

    getOptions():GridCellFooterOptions{
        return this.options
    }
} */

export enum HeadFootEnum{
    BOTH = "Both",
    HEADER_ONLY = "Header Only",
    FOOTER_ONLY = "Footer Only"
}
export interface GridCellHeader{
    headerTextSelector?:string,
    headerText?:string,
    headerLayoutClass?:string,
    fontSize?:number,
    fontWeight?:number,
    fontFamily?:string,
    color?:string,
    background?:string,

    hdrFntSizeClass?:FontSizeClasses, //preset font sizes
    hdrFontFam?:string, //inline
    hdrContBgClr?:string, // - inline - color
    hdrContLayoutClass?:ContainerLayouts, //Preset layout classes - top,bottom,middle
    hdrBorderWdtCls?:BorderWidths, // - class
    hdrBorderRdsCls?:BorderRadiuses,// - class
    hdrBorderColr?:string, //    - inline
    headerTxtClr?:string, //     - inline
    hdrParBgColor?:string, // - inline
    hdrPadCust?:string, // - inline
    hdrAlign?:HorisontalAlign // -inline


}


export enum FooterRendererType {
    PRODUCT_SUMMARY = "Product Summary",
    BLOG_SUMMARY = "Blog Summary"
}

export interface GridCellFooter{
    footerTextSelector?:string,
    footerText?:string,
    footerLayoutClass?:string,
    fontSize?:number,
    fontWeight?:number,
    fontFamily?:string,
    color?:string,
    background?:string,
    footerRendererType?:FooterRendererType
}
/*export enum RendererType{
    GRID = "grid",
    ROW = "row",
    BANNER = "banner",
    BLOGLIST = "bloglist",
    NEWSLETTER = "news-letter-sign-up",
    STOREFEATURES = "store-features",
    SLIDER = "slider",
    RICH_TEXT = "rich-text"
}*/
export interface Cell {
    cellId?:string;
    status?:ContentStatusEnum;
    imageOrientation?:OrientationEnum;
    imgSrc?:string;
    bgImgSrc?:string;
    width?:number,
    height?:number,
    layoutClass?:string;
    fillClass?:string;
    fillColor?:string;
    bgColor?:string;
    heightCls?:string;
    themeClass?:string;
    contentEnum?:ContentEnum;
    headerFooterEnum?:HeadFootEnum;
    bannerText?:string;
    hdrParBgColor?:string;
    hdrContLayoutClass?:string;
    contentElements?:ContentElement[];
    images?:ImageContentElement[];
    contentWidth?:string;
    contentHeight?:string;
    color?:string,
    cellVerticalAlign?:string;
    cellHorizontalAlign?:string;
    borderWidth?:string;
    borderColor?:string;
    borderStyle?:string;
    borderRadius?:string;
    border?:string
    padding?:string;
}

export interface GridCell extends Cell{
    colspan?:number;
    rowspan?:number;
    className?:GridCellClass;
    linkId?:string;
    gridRowStart?:number,
    gridRowEnd?:number,
    gridColumnStart?:number,
    gridColumnEnd?:number,
    heading?:GridCellHeader,
    footer?:GridCellFooter,
    bannerText?:string,
    contentEnum?:ContentEnum;
}

export interface GridOptions{
    contentEnum?:ContentEnum;
    numberOfElements?:number;
    variableImageSizes?:boolean;
    largeImageNumber?:boolean;
    largeImageOrientation?:OrientationEnum;
    largeImagePositionEnum?:LargeImagePositionEnum;
    hasFlipElements?:boolean;
    alignment?:string;
    headerPosition:HeaderFooterPosition;
    footerPosition:HeaderFooterPosition;
    gridCells:GridCell[];
    /* productsPerRowDesktop?:number;
    productsPerRowTablet?:number;
    productsPerRowMobile?:number;
    numberOfProductsShown?:number; */
    showSecondImageOnHover?:boolean;
    showVendorName?:boolean;
    hideActionButtons?:boolean;
    hideButtonsOnMobile?:boolean;
    buttonText?:string;
    buttonSizeDesktop?:string;
}
export interface RowCell extends Cell{
    className?:GridCellClass;
    linkId?:string;
    altImgSrc?:string;
    heading?:GridCellHeader
    footer?:GridCellFooter
}
export interface RowOptions {
    numberOfElements?:number;
    cellOrientation?:OrientationEnum;
    fullWidth?:boolean;
    rowCells?:RowCell[];
    layoutClass?:string;
    title?:string
}

export interface TextAppearance{
    color:string;
    fontSizeDesktop:number;
    fontSizeMobile:number;
    fontWeight:number;
    lineHeight:number;
    useBox:boolean;
    textBox?:TextBox;
}

export interface TextBox{
    boxBackgroundColor?:string;
    boxBorderRadius?:number;
    backgroundOpacity?:number;
    content:string;
}

export interface ImageWithText {
    src:string;
    textStyle?:TextAppearance;
    text:string;
}

export class ProductColumns extends KwikstoreSection<ProductColumns>{
    columnsPerRow:number;
    productsPerColumn:number;
    columnDetail:TextAppearance;

    constructor(options:{} = {}){
        super(options);
        this.columnsPerRow = options["columnsPerRow"];
        this.productsPerColumn = options["productsPerColumn"];
        this.columnDetail = options["columnDetail"]
    }
}

export class ProductRows extends KwikstoreSection<ProductRows>{
    gridOptions:GridOptions;
    constructor(options:{} = {}){
        super(options);
        this.gridOptions = options["gridOptions"];
    }
}
export class ProductSlider{
    gridOptions?:GridOptions;
    constructor(options:{} = {}){
        this.gridOptions = options["gridOptions"];
    }
}

export enum DisplayMode{
    INLINE = "inline",
    BLOCK = "block",
    DIALOG = "dialog"
}

export enum NewsLetterFormLocation{
    TOP = "top",
    MIDDLE = "middle",
    BOTTOM = "bottom"
}

export interface NewsLetterOptions{
    text1?:string;
    text2?:string;
    displayMode?:DisplayMode;
    imgSrc:string,
    formLocation?:NewsLetterFormLocation
}

export class NewsLetterSignUp extends KwikstoreSection<NewsLetterSignUp>{
    newsLetterOptions:NewsLetterOptions;
    constructor(options:{} = {}){
        super(options);
        this.newsLetterOptions = options["newsLetterOptions"];
    }
}

export interface SliderOptions{
    slides?:any[],
    layout?:string,
    tabs?:any[],
    showSlides?:any[],
    overLayGridContent?:any[],
    numberOfElements?:number,
    wrapperClass?:string,
    title?:ContentElement,
    sliderType?:SliderType,
    autoStart?:boolean,
    isPreview?:boolean
}

export class Slider extends KwikstoreSection<Slider>{
    sliderOptions:SliderOptions;
    constructor(options:{} = {}){
        super(options);
        this.sliderOptions = options["sliderOptions"];
    }
}

export class FeaturedProduct extends KwikstoreSection<FeaturedProduct>{
    gridOptions:GridOptions;
    constructor(options:{} = {}){
        super(options);
        this.gridOptions = options["gridOptions"];
    }
}

export class TabbedProductSlider extends KwikstoreSection<TabbedProductSlider>{
    productSliders:ProductSlider[];
    constructor(options:{} = {}){
        super(options);
        this.productSliders = options["productSliders"];
    }
}

export class Grid extends KwikstoreSection<Grid>{
    gridOptions:GridOptions;
    titleText:TextAppearance;
    descriptionText:TextAppearance;
    testText:string;
    text1:TextAppearance;
    text2:TextAppearance;
    text3:TextAppearance;
    constructor(options:{} = {}){
        super(options);
        this.gridOptions = options["gridOptions"];
        this.titleText = options["titleText"];
        this.descriptionText = options["descriptionText"];
        this.testText = "Fokof";
    }
}

export class Row extends KwikstoreSection<Row>{
    rowOptions:RowOptions;
    titleText:TextAppearance;
    descriptionText:TextAppearance;
    testText:string;
    text1:TextAppearance;
    text2:TextAppearance;
    text3:TextAppearance;
    constructor(options:{} = {}){
        super(options);
        this.rowOptions = options["rowOptions"];
        this.titleText = options["titleText"];
        this.descriptionText = options["descriptionText"];
        this.testText = "Fokof";
    }
}
export interface BannerOptions {
    numberOfElements?:number;
    layoutClass?:BannerLayoutEnum;
    cellOrientation?:OrientationEnum;
    bannerText?:string;
    header?:string;
    footer?:string;
    rowCells?:RowCell[];
}
export class Banner extends KwikstoreSection<Grid>{
    bannerOptions:BannerOptions;
    titleText:string;
    descriptionText:string
    constructor(options:{} = {}){
        super(options);
        this.bannerOptions = options["bannerOptions"];
        this.titleText = options["titleText"];
        this.descriptionText = options["descriptionText"];
    }
}
export class HeroImage extends Banner{
    constructor(options:{} = {}){
        super(options);
    }
}
export interface CollectionItem{
    imageWithText:ImageWithText;
    link:string;
}

export interface CollectionsOptions{
    titleText?:TextAppearance;
    descriptionText:TextAppearance;
    collectionItems:CollectionItem[];
}

export class CollectionsBannerMasonary {
    titleText:TextAppearance;
    descriptionText:TextAppearance;
    collectionItems:CollectionItem[];
    constructor(options:CollectionsOptions
    ){
        this.titleText = options.titleText;
        this.descriptionText = options.descriptionText;
        this.collectionItems = options.collectionItems
    }

}

export class CollectionsList{
    titleText?:TextAppearance;
    descriptionText:TextAppearance;
    collectionItems:CollectionItem[];
    constructor(options:CollectionsOptions
        ){
            this.titleText = options.titleText;
            this.descriptionText = options.descriptionText;
            this.collectionItems = options.collectionItems
        }
}

export interface TextContent{
    appearance:TextAppearance,
    content:string
}

export class BannerTexted{
    title:TextContent;
    detail:TextContent;
    imageUrl:string;
    imageAlignment:HorizontalAlignment;
    constructor(options:{
        title?:TextContent;
        detail?:TextContent;
        imageUrl?:string;
        imageAlignment?:HorizontalAlignment;
    } = {}){
        this.title = options.title;
        this.detail = options.detail;
        this.imageUrl = options.imageUrl;
        this.imageAlignment = options.imageAlignment
    }
}

export enum HorizontalAlignment {
    LEFT = "left",
    RIGHT = "right",
    CENTER = "center"
}

export enum LayoutStyle {
    STYLE_1 = "Style 1",
    STYLE_2 = "Style 2",
    STYLE_3 = "Style 3",
    STYLE_4 = "Style 4",
    STYLE_5 = "Style 5",
}
export class GridBanner{
    image1:ImageWithText;
    image2:ImageWithText;
    image3:ImageWithText;
    image4:ImageWithText;
    image5:ImageWithText;
    layout:LayoutStyle;
    constructor(options:{
        image1?:ImageWithText,
        image2?:ImageWithText,
        image3?:ImageWithText,
        image4?:ImageWithText,
        image5?:ImageWithText,
        layout?:LayoutStyle
    } = {}){
        this.image1 = options.image1;
        this.image1 = options.image1;
        this.image1 = options.image3;
        this.image1 = options.image4;
        this.image1 = options.image5;
        this.layout = options.layout || LayoutStyle.STYLE_1;
    }
}

export interface BlogSummary {
    imageWithText:ImageWithText;
    link:string;
    
}

export interface BlogListOptions {
    layout?:string;
    summaries?:BlogSummary[];
    cells?:RowCell[];
    link?:string;
    layoutClass?:BloglistLayoutEnum;
    themeClass?:string;
}

export class BlogList{
    blogSummaries:BlogSummary[];
    imageTop:boolean;
    constructor(options:{
        blogSummaries?:BlogSummary[],
        imageTop?:boolean
    } = {
        
    }){
        this.blogSummaries = options.blogSummaries;
        this.imageTop = options.imageTop;
    }
}

export class ImageSlideShow extends KwikstoreSection<ImageSlideShow>{
    constructor(options:{} = {}){
        super(options);
    }
}

export class LookBook extends KwikstoreSection<LookBook>{
    constructor(options:{} = {}){
        super(options);
    }
}

export class ParallaxBanner extends KwikstoreSection<ParallaxBanner>{
    constructor(options:{} = {}){
        super(options);
    }
}

export class SlideShow extends KwikstoreSection<SlideShow>{
    constructor(options:{} = {}){
        super(options);
    }
}
export interface StoreFeature{
    icon?:string;
    subHeading?:string;
    text?:string;
}
export interface StoreFeatureOptions{
    rendererType?:string;
    heading?:string;
    features?:StoreFeature[];
    invert?:boolean;
    rowCells:RowCell[];
}

export class StoreFeatures extends KwikstoreSection<StoreFeatures>{
    constructor(options:{} = {}){
        super(options);
    }
}

export interface RichTextOptions{
    rendererType?:string;
    heading?:string;
    content?:any;
    invert?:boolean;
    headerSizeClass?:"default" | "medium" | "small"; 
    rowCells?:RowCell[];
}
export class RichTextBlock extends KwikstoreSection<RichTextBlock>{
    constructor(options:{} = {}){
        super(options);
    }
}

export enum TestimonialLayoutEnum{
    LAYOUT_1 = "layout-1",
    LAYOUT_2 = "layout-2",
    LAYOUT_3 = "layout-3",
    LAYOUT_4 = "layout-4",
    FOUR_COL_PORTRIAT = "col-4-portrait",
    FOUR_COL_LAND = "col-4-landscape",
    THREE_COL_PORTRIAT = "col-3-portrait",
    TWO_COL_LAND = "col-2-landscape",
    ONE_COL_LAND = "col-1-landscape",
    THREE_VERTICAL = "Three vertical",
    TWO_HORISONTAL = "Two horisontal",
    ONE_HORISONTAL = "One horisontal"
}
export interface TestimonialOptions{
    rendererType?:string;
    heading?:string;
    bannerText?:any;
    layoutClass?:TestimonialLayoutEnum;
    rowCells?:RowCell[];
}

export class Testimonials extends KwikstoreSection<Testimonials>{
    constructor(options:{} = {}){
        super(options);
    }
}

export class TextLine extends KwikstoreSection<TextLine>{
    constructor(options:{} = {}){
        super(options);
    }
}



export class Video extends KwikstoreSection<Video>{
    constructor(options:{} = {}){
        super(options);
    }
}

export class Category extends KwikstoreSection<Category>{
    constructor(options:{} = {}){
        super(options);
    }
}
export class Cart extends KwikstoreSection<Cart>{
    constructor(options:{} = {}){
        super(options);
    }
}
export class Blog extends KwikstoreSection<Blog>{
    constructor(options:{} = {}){
        super(options);
    }
}

